import type { CityConfig } from "../city-template/types";

export const battleMountainConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — Nevada Dept of Health Vital Records", href: "https://dpbh.nv.gov/Programs/VitalRec/", description: "Official Nevada vital records office in Carson City" },
    { label: "Marriage Licenses — Lander County Clerk", href: "https://www.landercountynv.org/", description: "Lander County Clerk — marriage license issuance" },
    { label: "Divorce Records — Lander County Clerk", href: "https://www.landercountynv.org/", description: "Lander County Clerk — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of NV DOH for online vital record orders" },
  ],
  city: "Battle Mountain",
  state: "Nevada",
  stateAbbr: "NV",
  slug: "battle-mountain",
  route: "/battle-mountain",
  title: "Emergency Passport Battle Mountain NV | Expedited Passport Renewal Lander County | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport renewal in Battle Mountain, NV — 24-48 hour processing available. Fast passport services for Battle Mountain, Lander County, and I-80 corridor travelers. A+ BBB rated, State Dept. registered courier. No agency visit required.",
  h1: "Emergency & Expedited Passport Services in Battle Mountain, NV",
  heroSubtitle: "Passport expiring before your trip from Lander County? Fast Passport Center helps Battle Mountain, Lander County, and I-80 corridor travelers get expedited passports in as little as 24 hours. No agency visit required — Nevada has no local passport agency.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Battle%20Mountain%20Nevada%20wide%20open%20high%20desert%20landscape%20along%20the%20I-80%20corridor%20with%20distant%20mountain%20ranges%20and%20sagebrush%20terrain%2C%20small%20rural%20mining%20town%20atmosphere%20with%20clean%20wide%20streets%20and%20big%20sky%2C%20historic%20western%20Nevada%20charm%20with%20modern%20highway%20infrastructure%2C%20golden%20hour%20desert%20lighting%20casting%20long%20shadows%20across%20the%20Humboldt%20River%20valley%2C%20dramatic%20cloud%20formations%20over%20arid%20basin%20and%20range%20landscape%2C%20no%20text%20or%20people%20visible&width=1800&height=700&seq=battle-mountain-nv-hero-001&orientation=landscape",
  heroImageAlt: "Battle Mountain Nevada high desert landscape along the I-80 corridor with distant mountain ranges",
  geoPosition: "40.6421;-116.9343",
  geoPlacename: "Battle Mountain, Nevada",
  lastModified: "2026-06-06",
  regionalAgency: {
    name: "San Francisco Passport Agency",
    address: "95 Hawthorne St, Suite 600, San Francisco, CA 94105",
    distance: "Located in San Francisco — approximately 400 miles from Battle Mountain via I-80",
  },
  nearbyCitiesZips: [
    { name: "Battle Mountain", zips: "89820" },
    { name: "Winnemucca", zips: "89445" },
    { name: "Elko", zips: "89801" },
    { name: "Carlin", zips: "89822" },
    { name: "Spring Creek", zips: "89815" },
    { name: "Lovelock", zips: "89419" },
    { name: "Wells", zips: "89835" },
    { name: "Reno", zips: "89501" },
    { name: "Fallon", zips: "89406" },
    { name: "Fernley", zips: "89408" },
    { name: "Sparks", zips: "89431" },
    { name: "Carson City", zips: "89701" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Battle Mountain and Lander County departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — ship from any UPS location on the I-80 corridor" },
  ],
  internalLinks: [
    { name: "Emergency passport services in Elko", route: "/elko" },
    { name: "Fast passport renewal in Reno", route: "/reno" },
    { name: "Expedited passport help in Winnemucca", route: "/winnemucca" },
    { name: "Urgent passport services in Salt Lake City", route: "/salt-lake-city" },
    { name: "Same-day passport help in Boise", route: "/boise" },
    { name: "Passport courier services in Northern Nevada", route: "/nevada" },
  ],
  fpcOfficeAddress: "100 W Liberty St, Reno, NV 89501",
  fpcOfficeNote: "Fast Passport Center serves Battle Mountain remotely via secure overnight courier. We do not have a walk-in office in Battle Mountain — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Battle Mountain, Lander County, and the central I-80 corridor.",
  fpcOfficeDistance: "Serving all of Battle Mountain, Lander County, and the I-80 corridor between Winnemucca and Elko",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Battle Mountain and Lander County. As a historic mining and ranching community along the I-80 corridor, Battle Mountain serves as the county seat and a vital stop for travelers crossing northern Nevada. We provide fast passport processing for this remote but important community.",
  nearbyCitiesIntro: "We serve all Battle Mountain neighborhoods and Lander County communities, plus nearby towns along the I-80 corridor including Winnemucca, Elko, Carlin, Lovelock, and Wells. Our overnight shipping labels work from any UPS location — your rural Nevada location doesn't slow us down.",
  howItWorksIntro: "Most Battle Mountain travelers complete everything online and ship documents overnight. No need to drive hundreds of miles to Reno, Salt Lake City, or San Francisco. Our emergency passport process delivers fast results for central Nevada travelers.",
  mistakesIntro: "Battle Mountain and Lander County residents face some of the longest travel distances to government services in the lower 48. Here are the most common passport mistakes we see in rural central Nevada.",
  testimonialsIntro: "Battle Mountain and Lander County travelers trust us when their international departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Battle Mountain? Here are the most common ones we hear from Lander County and I-80 corridor travelers.",
  statePageRoute: "/states/nevada",
  statePageName: "Nevada",
  dmvWebsite: "https://dmv.nv.gov",
  dmvLabel: "Nevada DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Nearest agency is San Francisco (400 miles via I-80)",
        "Impossible day trip from Battle Mountain",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Battle Mountain travelers with immediate departure needs — as fast as 24 hours for urgent flights from Elko Regional or Reno-Tahoe International.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance for Battle Mountain and Lander County residents.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance — helpful for mining industry workers who travel internationally.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for Battle Mountain Nevada travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens in Battle Mountain NV and Lander County." },
    { name: "New Passport", description: "First-time passport application assistance for Battle Mountain and Lander County residents." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Rick T.",
      location: "Battle Mountain, NV",
      rating: 5,
      text: "Mining engineer heading to Chile for a project. Passport had expired without me noticing. Fast Passport Center got it renewed in 48 hours. From Battle Mountain! I couldn't believe the speed.",
      service: "Emergency Passport",
    },
    {
      name: "Debbie M.",
      location: "Lander County, NV",
      rating: 5,
      text: "Rancher with a family trip to Canada. Living an hour outside Battle Mountain, I was worried about the logistics. Overnight label worked perfectly and I had my passport in 3 days. Incredible service for rural Nevada.",
      service: "Passport Renewal",
    },
    {
      name: "Stan K.",
      location: "Battle Mountain, NV",
      rating: 5,
      text: "Trucking company owner needing a passport for cross-border freight meetings. They processed it in 2 days and I made my meeting in Vancouver. This service is a lifeline for I-80 corridor professionals.",
      service: "Emergency Passport",
    },
    {
      name: "Lorraine P.",
      location: "Winnemucca, NV",
      rating: 5,
      text: "Came over from Winnemucca for my son's first passport. The guidance was excellent — they walked us through every form. New passport arrived in 4 days. Even from central Nevada, the courier system is flawless.",
      service: "New Passport",
    },
  ],
  facilities: [
    {
      id: "battle-mountain-1",
      name: "Battle Mountain Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "450 W 4th St",
      city: "Battle Mountain",
      state: "NV",
      zip: "89820",
      phone: "(775) 635-2345",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Battle Mountain",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Lander County facility. Small office — call ahead to confirm passport acceptance times. Appointments recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "battle-mountain-2",
      name: "Lander County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "315 S Humboldt St",
      city: "Battle Mountain",
      state: "NV",
      zip: "89820",
      phone: "(775) 635-5738",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "Downtown Battle Mountain",
      website: "https://www.landercountynv.org/",
      websiteLabel: "Lander County Clerk",
      notes: "County government passport acceptance. Serves all Lander County. Call for appointment.",
      icon: "ri-government-line",
    },
    {
      id: "battle-mountain-3",
      name: "Winnemucca Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1025 W 4th St",
      city: "Winnemucca",
      state: "NV",
      zip: "89445",
      phone: "(775) 623-3362",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "50 miles west of Battle Mountain",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Next major facility west on I-80. Larger than Battle Mountain with more appointment availability.",
      icon: "ri-mail-line",
    },
    {
      id: "battle-mountain-4",
      name: "Elko Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "256 5th St",
      city: "Elko",
      state: "NV",
      zip: "89801",
      phone: "(775) 738-5026",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "70 miles east of Battle Mountain",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Largest passport facility in northeastern Nevada. Full services with appointment. 70 miles via I-80.",
      icon: "ri-mail-line",
    },
    {
      id: "battle-mountain-5",
      name: "Reno Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "50 S Virginia St",
      city: "Reno",
      state: "NV",
      zip: "89501",
      phone: "(775) 788-0900",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "215 miles west via I-80",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major Northern Nevada facility. Full services. 215 miles from Battle Mountain — plan for a full day trip if visiting in person.",
      icon: "ri-mail-line",
    },
    {
      id: "battle-mountain-6",
      name: "Carlin Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "110 S 8th St",
      city: "Carlin",
      state: "NV",
      zip: "89822",
      phone: "(775) 754-6364",
      hours: "Mon–Fri: 9:00 AM – 1:00 PM, 2:00 PM – 4:00 PM",
      distance: "50 miles east of Battle Mountain",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Small facility with very limited hours. Convenient for Carlin and west Elko County residents. Call ahead.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 400 miles to San Francisco", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Battle Mountain has extremely limited photo options — essentially only the post office. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or wrong form type are the #1 reasons for rejection at small rural Nevada acceptance facilities like the Battle Mountain Post Office.",
    },
    {
      icon: "ri-road-map-line",
      title: "Underestimating Travel Distance",
      description: "The nearest passport agency is 400 miles away in San Francisco — a 6+ hour drive across Nevada and the Sierra Nevada. Our courier service eliminates this impossible journey entirely.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation, the San Francisco regional agency will turn you away for emergency appointments — and you'll have driven 400 miles for nothing.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This is especially challenging in rural Lander County where both parents may work in mining on alternating shifts.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Nevada has no local passport agency. Standard processing takes 8–11 weeks. From Battle Mountain, mail transit alone adds days — start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Elko or Winnemucca." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Battle Mountain address — trackable every step of the way." },
  ],
  faqs: [
    {
      q: "How fast can I get an emergency passport in Battle Mountain, NV?",
      a: "Fast Passport Center offers emergency passport processing in Battle Mountain in as little as 24–48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities. Nevada has no local passport agency — the nearest is San Francisco, 400 miles away — so our courier service is the only practical fast option for Battle Mountain and Lander County travelers.",
    },
    {
      q: "What is the nearest passport agency to Battle Mountain?",
      a: "The nearest passport agency to Battle Mountain is the San Francisco Passport Agency, approximately 400 miles west via I-80 — a 6+ hour drive across Nevada and over the Sierra Nevada. This is not a practical day trip from Battle Mountain. Fast Passport Center's courier service means you never have to make that drive.",
    },
    {
      q: "Does Battle Mountain have a passport acceptance facility?",
      a: "Yes, the Battle Mountain Post Office at 450 W 4th St and the Lander County Clerk at 315 S Humboldt St both offer passport acceptance services by appointment. Both have limited hours and are small facilities. For larger options, the Winnemucca Post Office is 50 miles west and the Elko Main Post Office is 70 miles east via I-80.",
    },
    {
      q: "Do you serve mining industry workers in the Battle Mountain area?",
      a: "Absolutely. The Battle Mountain area has a strong mining industry presence with operations by Nevada Gold Mines and other companies. Many mining professionals travel internationally for conferences, site visits, and corporate meetings. Fast Passport Center serves all mining industry workers and their families with fast passport processing.",
    },
    {
      q: "What about ranching families in rural Lander County?",
      a: "Lander County is ranching country. Fast Passport Center understands the unique needs of rural families — our overnight shipping system works from any location, and we provide extra guidance for families who may not have easy access to photo services or acceptance facilities.",
    },
    {
      q: "Can I fly internationally from Elko Regional Airport?",
      a: "Elko Regional Airport is about 70 miles east of Battle Mountain and offers connecting flights to Salt Lake City and other hubs for international connections. Reno-Tahoe International Airport is 215 miles west with direct international service. Fast Passport Center ensures your passport is ready before departure from either airport.",
    },
    {
      q: "How much does expedited passport service cost in Battle Mountain?",
      a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by speed — emergency 24–48 hour, 3–5 day expedited, or standard options. Contact us for a personalized quote based on your departure date and processing speed.",
    },
  ],
  photoLocations: [
    { name: "Battle Mountain Post Office", address: "450 W 4th St, Battle Mountain, NV 89820", hours: "Mon–Fri: 9AM–4PM (photo by appointment)" },
    { name: "Walmart — Elko", address: "2660 Mountain City Hwy, Elko, NV 89801", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/" },
    { name: "Walgreens — Elko", address: "1795 Idaho St, Elko, NV 89801", hours: "Mon–Sun: 8AM–10PM", website: "https://www.walgreens.com/" },
    { name: "UPS Store — Elko", address: "2520 Mountain City Hwy, Elko, NV 89801", hours: "Mon–Fri: 8AM–6PM, Sat: 9AM–3PM", website: "https://www.theupsstore.com/" },
    { name: "Walmart — Winnemucca", address: "3010 Potato Rd, Winnemucca, NV 89445", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/" },
    { name: "Walgreens — Winnemucca", address: "1100 W 4th St, Winnemucca, NV 89445", hours: "Mon–Sun: 8AM–9PM", website: "https://www.walgreens.com/" },
    { name: "CVS Pharmacy — Reno (near I-80)", address: "6150 Mae Anne Ave, Reno, NV 89523", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "FedEx Office — Reno", address: "1201 Terminal Way, Reno, NV 89502", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://www.fedex.com/" },
  ],
  dmvLocations: [
    {
      name: "Nevada DMV — Elko",
      address: "3920 E Idaho St, Elko, NV 89801",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Closest DMV to Battle Mountain — about 70 miles via I-80. Full-service with REAL ID. Online appointment recommended.",
      featured: true,
    },
    {
      name: "Nevada DMV — Reno",
      address: "555 Wright Way, Carson City, NV 89711",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Primary Northern Nevada DMV. 215 miles from Battle Mountain. REAL ID processing. Online appointment recommended.",
      featured: true,
    },
    {
      name: "Lander County Clerk — Battle Mountain",
      address: "315 S Humboldt St, Battle Mountain, NV 89820",
      hours: "Mon–Fri: 8AM–5PM",
      note: "County government services for Lander County residents. Passport acceptance available.",
      featured: false,
    },
    {
      name: "Nevada DMV — Winnemucca Express",
      address: "3200 Traders Way, Winnemucca, NV 89445",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Smaller DMV express office in Winnemucca. Limited services — call ahead for passport-related documentation.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "EKO",
      name: "Elko Regional Airport",
      distance: "70 miles from Battle Mountain via I-80",
      address: "975 Terminal Way, Elko, NV 89801",
      note: "Closest airport to Battle Mountain. Connecting flights to Salt Lake City (SLC) for international connections. 70-mile drive via I-80.",
      flightUrl: "https://www.flyelko.com/",
      flightLabel: "Elko Regional Airport",
      featured: true,
    },
    {
      code: "RNO",
      name: "Reno-Tahoe International Airport",
      distance: "215 miles from Battle Mountain via I-80",
      address: "2001 E Plumb Ln, Reno, NV 89502",
      note: "Major Northern Nevada airport with direct international flights. 215-mile drive via I-80 — about 3 hours.",
      flightUrl: "https://www.renoairport.com/",
      flightLabel: "Reno-Tahoe Airport",
      featured: false,
    },
    {
      code: "SLC",
      name: "Salt Lake City International Airport",
      distance: "300 miles from Battle Mountain via I-80",
      address: "776 N Terminal Dr, Salt Lake City, UT 84122",
      note: "Major western hub airport. Accessible via I-80 east. Delta hub with extensive international connections.",
      flightUrl: "https://www.slcairport.com/",
      flightLabel: "Salt Lake City Airport",
      featured: false,
    },
  ],
};